// Hücre editörü Değer sekmesinin yapışkan alt düğme şeridi (Şirket adına onayla / İptal / Kaydet) —
// KpiCellEditor.tsx'ten salt taşıma (≤600 satır kuralı).

import { KPI_COPY } from "../../lib/kpi-ui";

export function KpiCellEditorActions(props: {
  canClientApprove: boolean;
  approving: boolean;
  onApprove: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  warning: boolean;
}): JSX.Element {
  const { canClientApprove, approving, onApprove, onCancel, onSubmit, warning } = props;
  return (
    <div
      className="flex justify-end gap-2 mt-3 flex-wrap"
      style={{
        position: "sticky",
        bottom: 0,
        background: "var(--color-surface)",
        paddingTop: 6,
      }}
    >
      {canClientApprove ? (
        <button
          type="button"
          data-testid="kpi-client-approve"
          disabled={approving}
          title={KPI_COPY.portal.approveForCompanyHint}
          onClick={onApprove}
          className="px-3 py-1.5 rounded-lg text-sm"
          style={{ border: "1px solid var(--color-primary)", color: "var(--color-primary)" }}
        >
          {KPI_COPY.portal.approveForCompany}
        </button>
      ) : null}
      <button
        type="button"
        onClick={onCancel}
        className="px-3 py-1.5 rounded-lg text-sm"
        style={{ border: "1px solid var(--color-border)", color: "var(--color-text-2)" }}
      >
        İptal
      </button>
      <button
        type="button"
        onClick={onSubmit}
        className="px-3 py-1.5 rounded-lg text-sm font-semibold"
        style={{ background: "var(--color-primary)", color: "var(--color-surface)" }}
      >
        {warning ? "Yine de kaydet ↵" : "Kaydet ↵"}
      </button>
    </div>
  );
}
